import { Modal as AndtModal } from 'antd';
import noop from 'lodash/noop';
import React from 'react';

const Modal = ({ title, visible, content, onOk, onCancel, confirmLoading }) => (
  <AndtModal
    title={title}
    open={visible}
    onOk={onOk}
    onCancel={onCancel}
    confirmLoading={confirmLoading}
  >
    <p>{content}</p>
  </AndtModal>
);

export default Modal;

Modal.defaultProps = {
  title: '',
  visible: false,
  content: '',
  onOk: noop,
  onCancel: noop,
  confirmLoading: false,
};
